import type { GameMode } from '../core/types/gameMode.types';
import type { ActivityPlugin, AnyActivityPlugin } from '../core/types/activity.types';
import { pollPlugin } from './poll/pollPlugin';
import { arenaPlugin } from './arena/arenaPlugin';
import { coopPlugin } from './coop/coopPlugin';
import { sandboxPlugin } from './sandbox/sandboxPlugin';
import { sequencerPlugin } from './sequencer/sequencerPlugin';
import { pinpointPlugin } from './pinpoint/pinpointPlugin';
import { wallPlugin } from './wall/wallPlugin';
import { completarPlugin } from './completar/completarPlugin';
import { desarrolloPlugin } from './desarrollo/desarrolloPlugin';
import { vinculaPlugin } from './vincula/vinculaPlugin';
import { agrupaPlugin } from './agrupa/agrupaPlugin';
import { dictadoPlugin } from './dictado/dictadoPlugin';
import { anatomiaPlugin } from './anatomia/anatomiaPlugin';
import { rhythmCanvasPlugin } from './rhythm_canvas/rhythm_canvasPlugin';
import { melodyStaffPlugin } from './melody_staff/melody_staffPlugin';
import { earTrainingPlugin } from './ear_training/ear_trainingPlugin';
import { infoBlockPlugin } from './info_block/info_blockPlugin';
import { canvasBreakdownPlugin } from './canvas_breakdown/canvas_breakdownPlugin';
import { symbolAnalysisPlugin } from './symbol_analysis/symbol_analysisPlugin';
import { geometryCanvasPlugin } from './geometry_canvas/geometry_canvasPlugin';
import { cartesianPlanePlugin } from './cartesian_plane/cartesian_planePlugin';
import { mathEquationPlugin } from './math_equation/math_equationPlugin';
import { numberLinePlugin } from './number_line/number_linePlugin';
import { countingCollectionPlugin } from './counting_collection/counting_collectionPlugin';
import { dataChartPlugin } from './data_chart/data_chartPlugin';
import { fractionModelPlugin } from './fraction_model/fraction_modelPlugin';
import { percentGridPlugin } from './percent_grid/percent_gridPlugin';
import {
  subtituloPlugin,
  destacadoPlugin,
  figuraPlugin,
  glosarioTablaPlugin,
  formulaDestacadaPlugin,
} from './guide_editorial/guideEditorialPlugins';
import { structuralBreakdownPlugin } from './structural_breakdown/structural_breakdownPlugin';
import { sourceAnalysisPlugin } from './source_analysis/source_analysisPlugin';

const registry: Record<GameMode, AnyActivityPlugin> = {
  poll: pollPlugin,
  arena: arenaPlugin,
  coop: coopPlugin,
  sandbox: sandboxPlugin,
  order: sequencerPlugin,
  point: pinpointPlugin,
  wall: wallPlugin,
  completar: completarPlugin,
  desarrollo: desarrolloPlugin,
  vincula: vinculaPlugin,
  agrupa: agrupaPlugin,
  dictado: dictadoPlugin,
  anatomia: anatomiaPlugin,
  rhythm_canvas: rhythmCanvasPlugin,
  melody_staff: melodyStaffPlugin,
  ear_training: earTrainingPlugin,
  info_block: infoBlockPlugin,
  canvas_breakdown: canvasBreakdownPlugin,
  symbol_analysis: symbolAnalysisPlugin,
  geometry_canvas: geometryCanvasPlugin,
  cartesian_plane: cartesianPlanePlugin,
  math_equation: mathEquationPlugin,
  number_line: numberLinePlugin,
  counting_collection: countingCollectionPlugin,
  data_chart: dataChartPlugin,
  fraction_model: fractionModelPlugin,
  percent_grid: percentGridPlugin,
  subtitulo: subtituloPlugin,
  destacado: destacadoPlugin,
  figura: figuraPlugin,
  glosario_tabla: glosarioTablaPlugin,
  formula_destacada: formulaDestacadaPlugin,
  structural_breakdown: structuralBreakdownPlugin,
  source_analysis: sourceAnalysisPlugin,
};

export function getActivityPlugin<M extends GameMode>(mode: M): ActivityPlugin<M> {
  const plugin = registry[mode];
  if (!plugin) throw new Error(`Activity plugin not registered: ${mode}`);
  return plugin as ActivityPlugin<M>;
}

export function listActivityPlugins(): AnyActivityPlugin[] {
  return Object.values(registry);
}

export function registerActivityPlugin(plugin: AnyActivityPlugin): void {
  registry[plugin.mode] = plugin;
}

export { registry as activityRegistry };
